$(window).on('load', () => {
  $('body').css('opacity', 1)
})